export default [
  {
    id: 10,
    name: {
      en: "Alone",
      nl: "Alleen"
    }
  },
  {
    id: 1,
    name: {
      en: "Close Family",
      nl: "Gezin"
    }
  },
  {
    id: 2,
    name: {
      en: "Children",
      nl: "Kinderen"
    }
  },
  {
    id: 3,
    name: {
      en: "Partner",
      nl: "Partner"
    }
  },
  {
    id: 4,
    name: {
      en: "Friends",
      nl: "Vrienden"
    }
  },
  {
    id: 5,
    name: {
      en: "Co-workers",
      nl: "Collega's"
    }
  },
  {
    id: 6,
    name: {
      en: "Family",
      nl: "Familie"
    }
  },
  {
    id: 7,
    name: {
      en: "Other",
      nl: "Anders"
    }
  }
];
